import styled from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'
import { pixelise } from 'tools/style'
import { colors, padding, paddingSizes } from 'theme/default'
import Div from 'components/Div'
import Flex from 'components/Flex'
import Form from 'components/Form'
import Modal, { CloseButton } from 'components/Modal'

export const ProductForm = styled(Div).attrs(() => ({
  width: '100%',
  as: Form
}))`
`

export const ProductFlexContainer = styled(Modal.FlexContainer).attrs(() => ({
  width: '100%',
  height: '100%',
  flexDirection: 'column'
}))`
  /* Fix Safari unable to calculate the height */
  /* stylelint-disable value-no-vendor-prefix */
  height: -webkit-fill-available;
  /* stylelint-enable value-no-vendor-prefix */
  background: ${props => props.theme.colorContainerColor};
  overflow-y: auto;
  position: relative;
  ${breakpoint('desktop')`
    width: 800px;
    height: 100%;
    max-height: ${props => props.maxHeight ? props.maxHeight : '90%'};
  `}
`

ProductFlexContainer.defaultProps = {
  theme: {
    colorContainerColor: colors.container
  }
}

export const ProductCloseButton = styled(CloseButton)`
  && {
    position: absolute;
    top: ${props => props.top ? pixelise(props.top) : '40px'};
    right: ${props => props.right ? pixelise(props.right) : '20px'};
    background-color: ${props => props.theme.colorContainerColor};
    padding: ${padding[paddingSizes.small]};
    cursor: pointer;
    z-index: 1;
  }
`
ProductCloseButton.defaultProps = {
  theme: {
    colorContainerColor: colors.container
  }
}

export const ProductWrapper = styled(Div)`
  flex: 1 1 auto;
  overflow: auto;
`

export const ProductDetailsContainer = styled(Flex).attrs(() => ({
  padding: paddingSizes.none,
  flexDirection: 'column'
}))`
  ${breakpoint('desktop')`
    padding: ${padding[paddingSizes.medium]};
    flex-direction: row;
  `}
`

export const ProductBody = styled(Modal.Body).attrs(() => ({
  padding: paddingSizes.none
}))`
  background-color: ${props => props.theme.colorContainerColor};

  /* overriding Modal.Body style */
  overflow: visible;
  ${breakpoint('destkop')`
    padding: ${padding[paddingSizes.none]};
  `}
`

ProductBody.defaultProps = {
  theme: {
    colorContainerColor: colors.container
  }
}

export const ProductFooter = styled(Modal.Footer).attrs(() => ({
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
}))`
  height: 70px;
  user-select: none;
  ${breakpoint('desktop')`
    padding: ${padding[paddingSizes.small]}
    ${padding[paddingSizes.extraLarge]};
  `}
`
